import React, { useState, useEffect, useRef } from 'react';
import RTButton from '../common/RTButton'; // Import RTButton
import RTTable from '../common/Table'; // Import RTTable
import RTSpinner from '../common/RTSpinner'; // Import RTSpinner
import '../common/rtCommon.css'; // Common styles
import './SelectPG.css'; // Specific styles for SelectPG
import { apiGet } from '../../api/apiClient';

const SelectPGAllocated = ({ onSelect }) => {
  const [searchText, setSearchText] = useState('');
  const [pgList, setPGList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInitiated, setSearchInitiated] = useState(false); // Track if search button is clicked
  const [selectedPGIndex, setSelectedPGIndex] = useState(null); // Track the selected PG index
  const searchInputRef = useRef(null); // Create a ref for the search input

  // Focus on search input when component mounts
  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleSearch = async () => {
    setSearchInitiated(true); // Mark search as initiated
    setLoading(true); // Show spinner
    setSelectedPGIndex(null); // Reset selection on new search
    try {
      // Use not_allocated=false to get allocated PGs
      const response = await apiGet(`/pg/search?search_text=${searchText}&not_allocated=false`);
      const data = response.data || []; // Ensure data is an array
      setPGList(data);
    } catch (error) {
      setPGList([]); // Clear list on error
      console.error('Error fetching PG list:', error);
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  const handleSelectPG = (pg) => {
    setSelectedPGIndex(pg.pg_id);
  };

  const handleConfirmSelection = () => {
    if (selectedPGIndex === null) {
      alert('Please select a Paying Guest from the list.');
      return;
    }
    const selectedPG = pgList.find(pg => pg.pg_id === selectedPGIndex);
    onSelect(selectedPG); // Trigger the onSelect callback with the selected PG
  };

  // Handle Enter key press for search
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="select-pg-section">
      <div className="select-pg-form">
        <label className="rt-form-label">Search Allocated Paying Guest:</label>
        <input
          ref={searchInputRef}
          type="text"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter name, phone number, or address"
          className="rt-input"
          autoFocus
        />
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <RTButton variant="secondary" onClick={handleSearch}>
            Search
          </RTButton>
        </div>
      </div>
      {loading && <RTSpinner />}
      
      {!loading && searchInitiated && (
        <>
          <RTTable
            data={pgList}
            showPagination={true}
            noDataText="No Allocated Paying Guests found for the search criteria."
            exportable={false}
            columns={[
              { Header: 'Name', accessor: 'name' },
              { Header: 'Phone', accessor: 'mobile' },
              { Header: 'Address', accessor: 'address' },
              { Header: 'Building', accessor: 'building_name' },
              {
                Header: 'Select',
                accessor: 'select',
                Cell: ({ row }) => (
                  <input
                    type="radio"
                    name="selectPG"
                    checked={selectedPGIndex === row.pg_id}
                    onChange={() => handleSelectPG(row)}
                  />
                ),
              }
            ]}
          />
          <div className="select-pg-actions">
            <RTButton
              variant="primary"
              disabled={selectedPGIndex === null}
              onClick={handleConfirmSelection}
            >
              Select PG
            </RTButton>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectPGAllocated;
